<template>
  <div class="floor1-wrapper">
    <div class="content">
      <div class="floor-title">
        <img src="~images/floor1/title1.png" alt>
      </div>
      <!-- <div class="download">
        <div class="store" @click="toAppStore" @mouseenter="appStoreEnter" @mouseleave="appStoreLeave">
          <img src="~images/floor1/app-store.png" v-show="!appStoreVisible">
          <img src="~images/floor1/app-store-gray.png" v-show="appStoreVisible">
        </div>
        <div class="store" @click="toAndroidStore" @mouseenter="andriodEnter" @mouseleave="andriodLeave">
          <img src="~images/floor1/android-store.png" v-show="!andriodVisible">
          <img src="~images/floor1/android-store-gray.png" v-show="andriodVisible">
        </div>
        <div class="code" @mouseenter="enter" @mouseleave="leave">
          <img class="small" src="~images/floor1/erweima-replace.png" alt v-if="!bigCodeVisible">
          <div class="big" v-if="bigCodeVisible">
            <img src="~images/common/erweima.jpg" alt class="big-img">
          </div>
        </div>
      </div> -->
    </div>
    <video class="video" autoplay="autoplay" :muted="muteStatus" loop>
      <source src="http://ggj-front.oss-cn-hangzhou.aliyuncs.com/mp4/official.mp4" type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bigCodeVisible: false,
      muteStatus: 'muted',
      isMute:false,
      appStoreVisible: false,
      andriodVisible: false,
    };
  },
  methods: {
    appStoreEnter() {
      this.appStoreVisible = true;
    },
    appStoreLeave() {
      this.appStoreVisible = false;
    },
    andriodEnter() {
      this.andriodVisible = true;
    },
    andriodLeave() {
      this.andriodVisible = false;
    },
    enter() {
      this.bigCodeVisible = true;
    },
    leave() {
      this.bigCodeVisible = false;
    },
    muteStatusCtrl (){
      this.isMute = !this.isMute;
      if(this.isMute){
          this.muteStatus = '';
      }else{
          this.muteStatus = 'muted';
      }
    },
    toAppStore(){
      location.href = "https://itunes.apple.com/cn/app/id1441491837"
    },
    toAndroidStore(){
      location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.banma"
    }
  }
};
</script>

<style scoped lang="less">
.floor1-wrapper{
  width: 100%;
  height: 100%;
  min-width: 1200px;
  position: relative;
  background-color: #000;
  opacity:0.8;
  .video{
    position: absolute;
    z-index: -999;
    width: 100%;
    //height: 100%;
  }
  .content{
    position: absolute;
    left: 0;
    top: 37.5%;
    width: 100%;
    .floor-title{
      margin-left: 7.5%;
      img{
        width: 49.6%;
      }
    }
    .download{
      margin-top: 71px;
      margin-left: 7.5%;
      display: flex;
      .store{
        cursor: pointer;
        margin-right: 24px;
        img{
          width: 197px;
        }
      }
      .code{
        cursor: pointer;
        width: 60px;
        height: 60px;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        .small{
          width: 60px;
          height: 60px;
        }
        .big{
          position: absolute;
          left: 0;
          top: 0;
          width: 0px;
          height: 0px;
          background-color: #fff;

          .big-img{
            width: 60px;
            height: 60px;
            border-radius: 10px;
            transition-duration:2s;
            transition-timing-function:ease;
            transition-delay:0s;
            transition-property:all;
          }
          .big-img:hover{
            width: 196px;
            height: 196px;
            background: #000;
          }
        }

      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/floor/floor_1.vue